// components/TextInput.tsx
import { useFormContext } from 'react-hook-form';

import type { GeneralFormProps } from '@/types/general';

import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormMessage,
} from '../ui/form';
import { Input } from '../ui/input';

type Props = {
  fieldType?: 'number' | 'text' | 'email' | 'password';
  startIcon?: string;
  endIcon?: string;
  size?: 'sm' | 'default' | 'lg' | null | undefined;
  onPaste?: (event: React.ClipboardEvent<HTMLInputElement>) => void;
} & GeneralFormProps;

function RHFShadcnTextField({
  name,
  title,
  description,
  placeholder,
  value: externalValue,
  onChange: externalOnChange,
  required,
  fieldType = 'text',
  startIcon,
  endIcon,
  disabled,
  size = 'default',
  onPaste,
}: Props) {
  const { control } = useFormContext<Record<string, string | number>>();

  return (
    <FormField
      control={control}
      name={name}
      render={({ field }) => (
        <FormItem className="mt-4 w-full">
          <FormControl>
            <Input
              {...field}
              inputSize={size}
              disabled={disabled}
              startIcon={startIcon}
              endIcon={endIcon}
              required={required}
              data-testid={field.name}
              type={fieldType}
              placeholder={placeholder}
              title={title}
              onChange={(e) => {
                const value
                  = fieldType === 'number'
                    ? Number(e.target.value)
                    : String(e.target.value);

                const newEvent = { ...e, target: { ...e.target, value } };

                if (externalOnChange) {
                  externalOnChange(newEvent);
                  return;
                }
                field.onChange(newEvent);
              }}
              onPaste={onPaste}
              value={field.value ?? externalValue ?? ''}
            />
          </FormControl>
          {description && <FormDescription>{description}</FormDescription>}
          <FormMessage />
        </FormItem>
      )}
    />
  );
}

export default RHFShadcnTextField;
